module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";


//////////////////
// WEBPACK FOOTER
// ./assetsAdmin/icons/italic.svg
// module id = 93
// module chunks = 0